import * as React from "react";
import { BulkQuestionContext } from "src/providers/BulkQuestions";

const useBulkQuestions = () => {
  return React.useContext(BulkQuestionContext);
};

export default useBulkQuestions;
